import * as Sentry from "@sentry/node";

export function globalErrorHandler(error: any): void {
  console.error(error);
  if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
    Sentry.captureException(error);
  }
}
